import { IconButton } from "@material-ui/core";
import { ArrowLeft, ArrowRight } from "@material-ui/icons";
import React, { useState } from "react";
import "./Insights.scss";

const titleJson: { [key: string]: string } = {
    best_in_genres: "Best in Genre",
    best_in_idea: "Best in Idea",
    best_predictors: "Best Predictors",
    other_point_of_view: "Other Point of View",
};

export type InsightItem = {
    review_protagonist: string;
    review_story_characters: string;
    review_story_dislike: string;
    review_story_like: string;
};

export type Insight = {
    best_in_genres: InsightItem[];
    best_in_idea: InsightItem[];
    best_predictors: InsightItem[];
    other_point_of_view: InsightItem[];
};

const Insights: React.FC<{ insights: Insight }> = ({ insights }) => {
    const [tab, setTab] = useState(0);

    const getTitle = () => {
        return titleJson[Object.keys(insights)[tab]];
    };

    const getInsight = () => insights[(Object.keys(insights)[tab]) as 'best_in_genres'];

    const handlePrev = () => setTab(s => s-1);
    const handleNext = () => setTab(s => s+1);

    return (
        <div className="card report-insights">
            <div className="d-flex">
                <div className="card_title">
                    Insights from <span>{getTitle()}</span>
                </div>
                <div className="d-flex">
                    <IconButton size={"small"} onClick={handlePrev} disabled={tab === 0}>
                        <ArrowLeft />
                    </IconButton>
                    <IconButton size={"small"} onClick={handleNext} disabled={tab === 3}>
                        <ArrowRight />
                    </IconButton>
                </div>
            </div>
            <div className="qna">
                <div className="question">What did you like about the story?</div>
                <div className="answer">{getInsight()[0]?.review_story_like}</div>
            </div>
            <div className="qna">
                <div className="question">What did you not like about the story?</div>
                <div className="answer">{getInsight()[0]?.review_story_dislike}</div>
            </div>
            <div className="qna">
                <div className="question">Which characters in the story stay with you and why?</div>
                <div className="answer">{getInsight()[0]?.review_story_characters}</div>
            </div>
            <div className="qna">
                <div className="question">Do you care what happens to the protagonist and why?</div>
                <div className="answer">{getInsight()[0]?.review_protagonist}</div>
            </div>
        </div>
    );
};

export default Insights;
